import './App.css';
import { Box
 } from '@chakra-ui/react';


import Main from './components/Main';

function App() {


  return (

    <Box>
    {/* <Nav ref={btnRef}/> */}
    <Main />
    </Box>
  );
}

export default App;
